module.exports = __webpack_public_path__ + "static/media/pronto-copec.04076bbc.jpg";